<template>
    <header>
        <div class="container-fluid h-100">
            <nav class="navbar navbar-expand-xl fixed-top d-flex align-items-center overlay-gradient-top pt-0">
                <a href="https://locomotion.nl">
                    <img src="https://locomotion.nl/img/logo.svg" class="logo">
                </a>
                <div class="navbar-wrapper ms-auto d-flex align-items-center">
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav">
                            <li class="nav-item"><a class="nav-link" href="https://www.locomotion.nl/assesmentinstrumenten">Assesmentinstrumenten</a></li>
                            <li class="nav-item"><a class="nav-link" href="https://www.locomotion.nl/kennisprojecten">Kennisprojecten</a></li>
                            <li class="nav-item"><a class="nav-link" href="https://www.locomotion.nl/publicaties">Publicaties</a></li>
                            <li class="nav-item"><a :href="selfUrl" class="nav-link">Winkeltje</a></li>
                            <li class="nav-item h-100 align-self-center cart ms-auto" v-if="showCart">
                                <button class="nav-link btn btn-primary" @click="openCart"><i class="fad fa-shopping-cart"></i><span
                                    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">{{ cart.getQuantity() }}</span></button>
                            </li>
                            <li :class="'nav-item h-100 align-self-center contact' + (!showCart ? ' ms-auto' : '')"><a class="nav-link btn"
                                                                                                                       href="mailto:nico@knibbe.info">Contact</a>
                            </li>
                        </ul>
                    </div>
                    <button class="navbar-toggler collapsed ms-auto mb-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-expanded="false"
                            aria-controls="navbarSupportedContent"
                            aria-label="Toggle navigation">
                        <span> </span>
                        <span> </span>
                        <span> </span>
                    </button>
                </div>
            </nav>
        </div>
        <section class="p-0 overflow-hidden header">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-6 col-md-8 col-12 image-bg header text-center">
                        <div class="background-image overlay multiply" style="background-image: url('https://locomotion.nl/admin/resources/img3885-kopie-w1920.jpg');"></div>
                        <div class="header-title d-flex h-100 align-items-center justify-content-center flex-column">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </header>
</template>

<script>
export default {
    name:  'DefaultHeader',
    props: ['cart', 'showCart'],
    data() {
        return {
            selfUrl: window.location.origin
        }
    },
    methods: {
        openCart() {
            if(this.$parent.$refs.hasOwnProperty('cartModal')) {
                this.$parent.$refs.cartModal.openCart();
            }
        },
    }
}
</script>
